export default {
  setSites(state, models) {
    state.sites = models
  },

  remove(state, id) {
    state.sites = state.sites.filter(item => item.id !== id)
  },

  add(state, payload) {
    state.sites.push(payload)
  },

  update(state, payload) {
    state.sites = state.sites.map(item => (item.id === payload.id ? payload : item))
  },
}
